module.exports = __webpack_public_path__ + "static/media/Phenikaa_Prati.b5521c2b.jpg";